import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import FormButton from '@/components/common/FormButton.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AverageSearchForm',
  props: {
  isLoading: {
    type: Boolean,
    required: true,
  },
},
  emits: ['submit'],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const route = useRoute()

const bowlerSearch = ref<string>(String())
const clubSearch = ref<string>(String())

const emit = __emit



function onRouteChange(): void {
  bowlerSearch.value = (route.query.bowler ?? String()) as string
  clubSearch.value = (route.query.club ?? String()) as string

  if (bowlerSearch.value.length > 0 || clubSearch.value.length > 0) {
    submit()
  }
}

function setQuery(): void {
  router.replace({
    path: '/averages',
    query: {
      bowler: bowlerSearch.value,
      club: clubSearch.value,
    },
  })
}

function submit(): void {
  emit('submit', {
    bowler: bowlerSearch.value,
    club: clubSearch.value,
  })
}

onMounted(onRouteChange)

watch(() => route.query, onRouteChange)

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("form", {
    class: "average-search-form",
    onSubmit: _withModifiers(setQuery, ["prevent"])
  }, [
    _createVNode(FormTextInput, {
      modelValue: bowlerSearch.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bowlerSearch).value = $event)),
      type: "text",
      label: _ctx.$t('field-labels.bowler-search'),
      "is-disabled": __props.isLoading,
      autocomplete: "off"
    }, null, 8, ["modelValue", "label", "is-disabled"]),
    _createVNode(FormTextInput, {
      modelValue: clubSearch.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clubSearch).value = $event)),
      type: "text",
      label: _ctx.$t('field-labels.club-search'),
      "is-disabled": __props.isLoading,
      autocomplete: "off"
    }, null, 8, ["modelValue", "label", "is-disabled"]),
    _createVNode(FormButton, { "is-busy": __props.isLoading }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('averages.search')), 1)
      ]),
      _: 1
    }, 8, ["is-busy"]),
    _createVNode(FormButton, {
      class: "inline",
      "is-busy": __props.isLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FontAwesomeIcon, { icon: "magnifying-glass" })
      ]),
      _: 1
    }, 8, ["is-busy"])
  ], 32))
}
}

})